<!-- <h1 class="fs-18 mbm">Ou se situe le bien ?</h1> -->
<div class="d-flex flex-md-column gap-xl mbxl w-auto">
  <div class="d-flex flex-column w-60">
    <h1 class="fs-18 mtm mbl fw-600">Critères qui rendent ce bien unique</h1>
    <div class="d-flex criteria">
      <div
        class="d-flex flex-column justify-content-center align-items-center gap-xs"
        [ngClass]="!product?.hasParking ? 'op-2' : ''"
      >
        <img
          [src]="
            darkMode
              ? 'assets/img/parking-dmode.png'
              : 'assets/img/parking-lmode.png'
          "
          alt=""
          width="46"
          height="45"
        />
        <p class="text-bold phs fs-14 text-center">Parking</p>
      </div>
      <div
        class="d-flex flex-column justify-content-center align-items-center gap-xs"
        [ngClass]="!product?.hasGarden && !product?.hasTerrace ? 'op-2' : ''"
      >
        <img
          [src]="
            darkMode
              ? 'assets/img/terrace-dmode.png'
              : 'assets/img/terrace-lmode.png'
          "
          alt=""
          width="45"
          height="45"
        />
        <p class="text-bold phs fs-14 text-center">Jardin / Terrasse</p>
      </div>
      <div
        class="d-flex flex-column justify-content-center align-items-center gap-xs"
        [ngClass]="!product?.hasCellar ? 'op-2' : ''"
      >
        <img
          [src]="
            darkMode
              ? 'assets/img/cellar-dmode.png'
              : 'assets/img/cellar-lmode.png'
          "
          alt=""
          width="46"
          height="45"
        />
        <p class="text-bold phs fs-14 text-center">Cave</p>
      </div>
      <div
        class="d-flex flex-column justify-content-center align-items-center gap-xs"
        [ngClass]="!product?.hasLoggia ? 'op-2' : ''"
      >
        <img
          [src]="
            darkMode
              ? 'assets/img/loggia-dmode.png'
              : 'assets/img/loggia-lmode.png'
          "
          alt=""
          width="46"
          height="45"
        />
        <p class="text-bold phs fs-14 text-center">Loggia</p>
      </div>
    </div>
  </div>
  <div>
    <h1 class="fs-18 mtm mbl fw-600">
      {{ product?.program?.city }},
      {{ product?.program?.cityData?.departmentName }}, France
    </h1>
    <p class="text-secondary fw-400 mbl">
      {{ product?.program?.cityData?.cityDescription }}
    </p>
    <google-map [options]="mapOptions" width="100%">
      <map-marker [position]="marker?.position"></map-marker>
    </google-map>
    <div id="address-panel">
      <pr-label name="sp-map_pin"
        >{{ product?.program?.address }}, {{ product?.program?.postalCode }}
        {{ product?.program?.city }}
      </pr-label>
    </div>
  </div>
</div>

<h1 class="fs-18 mbm">
  Quels sont les critères utilisés par l’algorithme de Gridky
</h1>
@if (properties) {
  <div class="d-flex gap-m flex-wrap">
    @for (property of properties; track property) {
      <div class="property-item">
        <h4>{{ property.title }}</h4>
        <div class="d-flex ratingNotes">
          @for (index of _.range(5); track index) {
            <pr-icon
              [name]="
                index + 1 <= property.rating
                  ? 'sp-star_filled'
                  : 'sp-star_outline'
              "
              [viewBoxWidth]="24"
              [viewBoxHeight]="22"
            ></pr-icon>
          }
          <span
            class="fs-12 fw-400"
            style="line-height: 22px; margin-left: 5px"
          >
            <b>{{ property.rating }}/5</b> par notre algorithme</span
          >
        </div>
        <p>{{ property.description }}</p>
      </div>
    }
  </div>
}
